"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseSvg = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
exports.BaseSvg = styled_components_1.default.svg.withConfig({ displayName: "BaseSvg", componentId: "sc-ak73ru" })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["display:inline-flex;width:", ";height:", ";flex-shrink:0;user-select:none;"], ["", "", ""])), function (_a) {
    var $width = _a.$width;
    return $width;
}, function (_a) {
    var $height = _a.$height;
    return $height;
});
var templateObject_1;
